
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11190",
                "data-name": "矩形 11190",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.091 -0.422)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_231",
        "data-name": "蒙版组 231",
        "class": "cls-2",
        "transform": "translate(0.091 0.422)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "gymnasium",
            "class": "cls-3",
            "d": "M71.65,221.867a2.512,2.512,0,0,0-2.46,2.547v1.4h-4.92v-1.4a2.462,2.462,0,1,0-4.92,0v.127c-.246,0-.369-.127-.615-.127a1.926,1.926,0,0,0-1.845,1.91v3.82a1.926,1.926,0,0,0,1.845,1.91,1.077,1.077,0,0,0,.615-.127v.127a2.462,2.462,0,1,0,4.92,0v-1.146h4.92v1.146a2.462,2.462,0,1,0,4.92,0v-.127a1.077,1.077,0,0,0,.615.127,1.926,1.926,0,0,0,1.845-1.91v-3.82a1.926,1.926,0,0,0-1.845-1.91,1.077,1.077,0,0,0-.615.127v-.127A2.512,2.512,0,0,0,71.65,221.867Zm0,11.462a1.183,1.183,0,0,1-1.23-1.274v-7.641a1.231,1.231,0,1,1,2.46,0v7.641A1.183,1.183,0,0,1,71.65,233.328Zm-9.841,0a1.183,1.183,0,0,1-1.23-1.274v-7.641a1.231,1.231,0,1,1,2.46,0v7.641A1.183,1.183,0,0,1,61.809,233.328Zm12.916-2.547a.592.592,0,0,1-.615-.637v-3.82a.592.592,0,0,1,.615-.637.672.672,0,0,1,.615.637v3.82A.592.592,0,0,1,74.725,230.781Zm-15.991,0a.592.592,0,0,1-.615-.637v-3.82a.592.592,0,0,1,.615-.637.672.672,0,0,1,.615.637v3.82A.592.592,0,0,1,58.734,230.781Zm5.535-1.146v-2.547h4.92v2.547Z",
            "transform": "translate(-54.98 -216.289)"
          }
        }
      ]
    }
  ]
})
    }
  